import type { Tier } from "@schema/catalog.ts";
import { useCatalog } from "@/lib/catalog/context.tsx";
import styles from "./TierBadge.module.css";

const TIER_CLASS: Record<Tier, string> = {
  essential: styles.essential ?? "",
  important: styles.important ?? "",
  contextual: styles.contextual ?? "",
  optional: styles.optional ?? "",
  skippable: styles.skippable ?? "",
};

export function TierBadge({ tier }: { tier: Tier }) {
  const catalog = useCatalog();
  const def = catalog.tiers.find((t) => t.id === tier);
  return (
    <span className={`${styles.badge} ${TIER_CLASS[tier]}`} title={def?.description}>
      {def?.label ?? tier}
    </span>
  );
}
